// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1jSdU","inner":"Form_inner__2vK43","range":"Form_range__3KPLf","name":"Form_name__3iu5N","actions":"Form_actions__11anj"};